<template>
  <ion-page>
    <ion-content>
      <ion-card style="box-shadow: none; display: flex; flex-direction: column; justify-content: space-between">
        <div>
          <ion-card-header>
            <PageNavigation page-precedente="activitee1" page-suivante="activitee3" :page-title="pageTitle" :show-left-arrow="true" :show-right-arrow="true" />
            <ion-card-subtitle>Voici l’image que tu vas retrouver tout au long du Salon. À ton avis, <strong> pourquoi a-t-on choisi cette image ? </strong> Ecris tes réponses dans les cases en dessous de l'image !</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <img src="@/assets/salon24_visuel sans logo.jpg" alt="image du salon de la formation 2024">
            <div class="text-area-container">
              <textarea placeholder="Possibilité 1" :disabled="inputDesactive" v-model="textAreaDefImage1"></textarea>
              <textarea placeholder="Possibilité 2" :disabled="inputDesactive" v-model="textAreaDefImage2"></textarea>
              <textarea placeholder="Possibilité 3" :disabled="inputDesactive" v-model="textAreaDefImage3"></textarea>
              <textarea placeholder="Possibilité 4" :disabled="inputDesactive" v-model="textAreaDefImage4"></textarea>
            </div>
            <!--<p v-show="showText">
              <i>
                Représentation de l'ascension professionnelle : La fusée décollante peut symboliser la croissance et le
                développement professionnels. La personne à bord de la fusée pourrait représenter un individu qui se
                forme et se prépare pour une carrière ascendante, prête à décoller vers de nouveaux horizons professionnels.
              </i>
            </p>-->
          </ion-card-content>
        </div>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script>

import {defineComponent} from "vue";
import {
  IonCard,
  IonCardContent,
  IonCardHeader, IonCardSubtitle,
  IonContent,
  IonPage
} from "@ionic/vue";
import PageNavigation from "@/components/PageNavigation.vue";

export default defineComponent({
  components: {
    PageNavigation,
    IonContent,
    IonCardSubtitle,
    IonCard,
    IonPage,
    IonCardHeader,
    IonCardContent
  },
  data() {
    return {
      pageTitle: '2/4 Pourquoi cette image ?',
      textAreaDefImage1: '',
      textAreaDefImage2: '',
      textAreaDefImage3: '',
      textAreaDefImage4: '',
      showText : false,
      validate : false,
      inputDesactive : false,
    }
  },
  watch: {
    textAreaDefImage1(newVal) {
      localStorage.textAreaDefImage1 = newVal;
      console.log(newVal);
    },
    textAreaDefImage2(newVal) {
      localStorage.textAreaDefImage2 = newVal;
      console.log(newVal);
    },
    textAreaDefImage3(newVal) {
      localStorage.textAreaDefImage3 = newVal;
      console.log(newVal);
    },
    textAreaDefImage4(newVal) {
      localStorage.textAreaDefImage4 = newVal;
      console.log(newVal);
    }
  },
  mounted() {
    console.log('Before retrieval from localStorage:');
    console.log(localStorage.textAreaDefImage1);
    console.log(localStorage.textAreaDefImage2);
    console.log(localStorage.textAreaDefImage3);
    console.log(localStorage.textAreaDefImage4);

    this.textAreaDefImage1 = localStorage.textAreaDefImage1 || '';
    this.textAreaDefImage2 = localStorage.textAreaDefImage2 || '';
    this.textAreaDefImage3 = localStorage.textAreaDefImage3 || '';
    this.textAreaDefImage4 = localStorage.textAreaDefImage4 || '';

    console.log('After retrieval from localStorage:');
    console.log(this.textAreaDefImage1);
    console.log(this.textAreaDefImage2);
    console.log(this.textAreaDefImage3);
    console.log(this.textAreaDefImage4);
  }
})
</script>

<style scoped>

ion-card {
  box-sizing: border-box;
  margin: 0;
}

ion-card-header {
  margin-top: 80px;
}

ion-select {
  display: inline-flex;
  width: 40%;
  border-bottom: solid 2px #e30613;
  height: 20px;
}

.text-area-container {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: 260px;
  gap: 10px;

  textarea {
    height: 100%;
    width: 100%;
    border: none;
    border-radius: 5px;
    padding: 0.5em;
    font-size: 1rem;
    color: #1a1a1a;

    &:nth-child(1) {
      background: #D797C2;
    }
    &:nth-child(2) {
      background: #C4DF9B;
    }
    &:nth-child(3) {
      background: #95B5DE;
    }
    &:nth-child(4) {
      background: #FED998;
    }
  }
}

ion-card-content {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

img {
  margin-top: 1em;
  border-radius: 5px;
}

@media only screen and (max-width: 370px) {
  .text-area-container {
    grid-template-columns: repeat(1, 1fr);
    height: 400px;
  }
}

</style>
